export default __webpack_public_path__ + "images/00026376665743607c651ee76452987f-invoice.svg";